export default {"src":"/_next/static/media/ic-clear-black.02bd5ecd.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};